import React from "react";

// Dashboard
const PropertyERPDashboard = React.lazy(
  () => import("../../Property/DashboardPage/PropertyERPDashboard"),
);

// Units
const CompletedUnits = React.lazy(() => import("../../Property/Units/CompletedUnits"));

// Charge Heading
const ChargeHeading = React.lazy(() => import("../../Property/Finances/ChargeHeading"));
const AddChargeHeadingForm = React.lazy(
  () => import("../../Property/Finances/AddChargeHeadingForm"),
);

// Billing - Invoice Batch
const InvoiceBatch = React.lazy(() => import("../../Property/Billing/Invoices/InvoiceBatch"));
const AddInvoiceForm = React.lazy(() => import("../../Property/Billing/Invoices/AddInvoiceForm"));

// Billing - Unit Invoices
const Invoice = React.lazy(() => import("../../Property/Billing/Invoices/Invoice"));

// Billing - Void Invoices
const VoidInvoices = React.lazy(() => import("../../Property/Billing/Invoices/VoidInvoices"));

// Billing - Invoice Receipts
const InvoiceReceiptTable = React.lazy(
  () => import("../../Property/Billing/InvoiceReceipt/InvoiceReceiptTable"),
);
const InvoiceReceiptForm = React.lazy(
  () => import("../../Property/Billing/InvoiceReceipt/InvoiceReceiptForm"),
);

export const propertyRoutes = [
  // {
  //   path: "/property-management/dashboard",
  //   Component: PropertyDashboard,
  //   rolename: "Property Management_Dashboard",
  // },
  {
    path: "/property-management/dashboard",
    Component: PropertyERPDashboard,
    rolename: "Property Management_Dashboard",
  },

  // Units
  {
    path: "/property-management/units",
    Component: CompletedUnits,
    rolename: "ERP-Property Management_Units",
  },

  // Charge Heads
  {
    path: "/property-management/charge-heads",
    Component: ChargeHeading,
    rolename: "Property Management_Charge Head",
  },
  {
    path: "/property-management/charge-heads/add",
    Component: AddChargeHeadingForm,
    rolename: "Charge Head_Create",
  },

  // Billing - Invoice Batches
  {
    path: "/property-management/billing/invoice-batches",
    Component: InvoiceBatch,
    rolename: "Billing_Invoice Batches",
  },
  {
    path: "/property-management/billing/invoice-batches/add",
    Component: AddInvoiceForm,
    rolename: "Invoice Batches_Create",
  },

  // Billing - Unit Invoices
  {
    path: "/property-management/billing/unit-invoices",
    Component: Invoice,
    rolename: "Billing_Unit Invoices",
  },

  // Billing - Void Invoices
  {
    path: "/property-management/billing/void-invoices",
    Component: VoidInvoices,
    rolename: "Billing_Void Invoices",
  },

  // Billing - Invoice Receipts
  {
    path: "/property-management/billing/invoice-receipts",
    Component: InvoiceReceiptTable,
    rolename: "Billing_Invoice Receipts",
  },
  {
    path: "/property-management/billing/invoice-receipts/add",
    Component: InvoiceReceiptForm,
    rolename: "Invoice Receipts_Create",
  },
];
